import $ from "jquery";

import { openMenu, removeEachProduct, openCart, closeCart } from './template-parts/header/header'
import { setSlider, setHero } from './template-parts/parts/slider'
import { showAllCategories, showModalCart } from './template-parts/parts/dropdawn'
import {addToBasket} from "./template-parts/parts/product";
import {showSearch} from "./template-parts/parts/showSearch";
import {showMobileMenu} from "./template-parts/parts/showMobileMenu";
import {setTotal} from "./template-parts/parts/setTotal";



openMenu();
openCart();
closeCart();
setSlider();
setHero();
showAllCategories();
showModalCart();
removeEachProduct();
addToBasket();
showSearch();
showMobileMenu();
setTotal();
